export default function configureModerator (store, router) {
  // listen to mutations
  store.subscribe(({ type, payload }, state) => {
    console.log('mutation', type)
    switch (type) {
      case 'auth/setToken':
        return store.dispatch('service/fetchData')
      default:
        // console.log('mutation', type)
    }
  })
  // listen to actions
  // note: doesn't not wait for the result of async actions
  store.subscribeAction(({ type, payload }, state) => {
    // console.log('actions', type)
    switch (type) {
      case 'auth/signOut': return router.push('/auth/signin')
      default:
        // console.log('actions', type)
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/store-moderator.js